export const DEV_KEY = '__dev';

export const AQA_KEY = 'aqa';
